import {Component, OnInit, Inject, Input, ChangeDetectionStrategy} from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';

import { SystemPaths } from './system-paths';
import { SystemUtils } from './systemutils';

import { GetGameSummariesForSeasonService } from '../service/get-game-summaries-for-season.service';

declare var dateFormat;

@Component({
    selector: 'league-header',
    template: `
<ol class="breadcrumb league-header">
    <li>
        <span style="color: #ffffff; font-weight: bold;">{{leagueAbbr | uppercase}}</span>&nbsp;
        <div class="btn-group dropdown" is-open="isLeagueHeaderBtnOpen">
            <button type="button" class="btn btn-sm btn-default" (click)="gotoSelectedPage($event)">{{selectedLeaguePage}}</button>
              <button type="button" class="btn btn-sm btn-default dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">
                  <span class="caret"></span>
                <span class="sr-only">Split button!</span>
            </button>
            <ul class="dropdown-menu" role="menu">
                <li><a href="" class="dropdown-toggle" (click)="gotoSchedulePage($event)">Scores</a></li>
                <ng-template [ngIf]="selectedLeaguePage == 'Scores'">
                    <li *ngFor="let todaysGame of games">
                        <a href="" class="dropdown-toggle" (click)="gotoGamePage($event, todaysGame.game.id)">
                            &nbsp;&nbsp;&nbsp;&nbsp;{{todaysGame.game.awayTeamCtx.abbreviation}}
                            <span *ngIf="todaysGame.game.playStatus == 'IN_PROGRESS' || todaysGame.game.playStatus == 'LIVE_PENDING_REVIEW'" style="padding:2px; background-color: #939393; border-radius: 2px; color: #000000;">
                                {{todaysGame.gameUpdate.awayScore}}
                            </span>
                            <span *ngIf="todaysGame.game.playStatus == 'COMPLETED'" style="padding:2px; background-color: #939393; border-radius: 2px; color: #000000;">
                                {{todaysGame.game.awayScore}}</span>
                            &nbsp;@
                            <span *ngIf="todaysGame.game.playStatus == 'IN_PROGRESS' || todaysGame.game.status == 'LIVE_PENDING_REVIEW'" style="padding:2px; background-color: #939393; border-radius: 2px; color: #000000;">
                                {{todaysGame.gameUpdate.homeScore}}
                            </span>
                            <span *ngIf="todaysGame.game.playStatus == 'COMPLETED'" style="padding:2px; background-color: #939393; border-radius: 2px; color: #000000;">
                                {{todaysGame.game.homeScore}}</span>
                            {{todaysGame.game.homeTeamCtx.abbreviation}}
                            <span *ngIf="todaysGame.game.awayScore || todaysGame.game.homeScore" style="color: #ff8800; font-weight: bold;">(Final)</span>
                        </a>
                    </li>
                </ng-template>
                <li><a href="" class="dropdown-toggle" (click)="gotoStandingsPage($event)">Standings</a></li>
                <li><a href="" class="dropdown-toggle" (click)="gotoStatsPage($event)">Stats</a></li>
                <li><a href="" class="dropdown-toggle" (click)="gotoPlayersPage($event)">Players</a></li>
            </ul>
        </div>
    </li>
    <li *ngIf="game && game._playDate" class="active">{{game._playDate}}: {{game.awayTeamCtx.abbreviation}}@{{game.homeTeamCtx.abbreviation}}</li>
    <li *ngIf="playerCtx" class="active">{{playerCtx.personCtx.person.lastName}}, {{playerCtx.personCtx.person.firstName}}</li>
    <li *ngIf="teamCtx" class="active">{{teamCtx.abbreviation}}</li>
</ol>`,
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['../../assets/packages/mysportsfeeds/css/common.css']
})
export class LeagueHeaderComponent implements OnInit {
    @Input() game;
    @Input() games;
    @Input() playerCtx;
    @Input() teamCtx;

    public selectedLeaguePage: string;
    public leagueAbbr: string;

    constructor( @Inject(DOCUMENT) protected document: any,
        private systemUtils: SystemUtils,
        private systemPaths: SystemPaths,
        private GetGameSummariesForSeasonService: GetGameSummariesForSeasonService) {

        this.selectedLeaguePage = null;
        this.leagueAbbr = null;
	}

    ngOnInit() {
        var scheduleIdx = this.document.location.href.indexOf("/schedule");
        var standingsIdx = this.document.location.href.indexOf("/standings");
        var playersIdx = this.document.location.href.indexOf("/players");
        var leadersIdx = this.document.location.href.indexOf("/stats");
        if (scheduleIdx > 0) {
            this.leagueAbbr = this.document.location.href.substring(0, scheduleIdx);
            this.leagueAbbr = this.leagueAbbr.substring(this.leagueAbbr.lastIndexOf("/") + 1);
            this.selectedLeaguePage = "Scores";

            if ( this.game ) {
                this.getGames();
            }
        } else if (standingsIdx > 0) {
            this.leagueAbbr = this.document.location.href.substring(0, standingsIdx);
            this.leagueAbbr = this.leagueAbbr.substring(this.leagueAbbr.lastIndexOf("/") + 1);
            this.selectedLeaguePage = "Standings";
        } else if (playersIdx > 0) {
            this.leagueAbbr = this.document.location.href.substring(0, playersIdx);
            this.leagueAbbr = this.leagueAbbr.substring(this.leagueAbbr.lastIndexOf("/") + 1);
            this.selectedLeaguePage = "Players";
        } else if (leadersIdx > 0) {
            this.leagueAbbr = this.document.location.href.substring(0, leadersIdx);
            this.leagueAbbr = this.leagueAbbr.substring(this.leagueAbbr.lastIndexOf("/") + 1);
            this.selectedLeaguePage = "Stats";
        }

        if (this.playerCtx) {
            this.document.title = this.playerCtx.personCtx.person.firstName + " " + this.playerCtx.personCtx.person.lastName + " : " + this.leagueAbbr.toUpperCase() + " : MySportsFeeds.com";
        }

        if (this.teamCtx) {
            this.document.title = this.teamCtx.city + " " + this.teamCtx.name + " : " + this.leagueAbbr.toUpperCase() + " : MySportsFeeds.com";
        }
    }

    public getGames() {
        let playDate: Date = this.systemUtils.parseSystemDateTime(this.game.playDateTime);
        let dayNum: number = playDate.getDay();
        this.game._playDate = dateFormat(playDate, "mmm d");
        this.game._playTime = dateFormat(playDate, 'h:MM TT (Z)');

        var currentDate = this.systemUtils.parseSystemDate(this.game.playDateTime);
        var nextDate = new Date(currentDate.getTime());
        nextDate.setDate(nextDate.getDate() + 1);

        var requestObj = {
            leagueId: this.leagueAbbr,
            seasonId: this.game.season.id,
            startDate: dateFormat(currentDate, 'yyyy-mm-dd'),
            endDate: dateFormat(nextDate, 'yyyy-mm-dd'),
            offset: 0
        };

        this.GetGameSummariesForSeasonService.get(requestObj).subscribe(
            response => {
                this.games = response;
            }
        );
    }

    public gotoSchedulePage($event) {
        $event.preventDefault();
        this.document.location = this.systemPaths.schedule(this.leagueAbbr);
    }

    public gotoStandingsPage($event) {
        $event.preventDefault();
        this.document.location = this.systemPaths.standings(this.leagueAbbr);
    }

    public gotoPlayersPage($event) {
        $event.preventDefault();
        this.document.location = this.systemPaths.playerList(this.leagueAbbr);
    }

    public gotoStatsPage($event) {
        $event.preventDefault();
        this.document.location = this.systemPaths.stats(this.leagueAbbr);
    }

    public gotoGamePage($event, gameId) {
        $event.preventDefault();
        this.document.location = this.systemPaths.gameSummary(this.leagueAbbr, gameId);
    }

    public gotoSelectedPage($event) {
        $event.preventDefault();

        if (this.selectedLeaguePage == "Scores") {
            this.gotoSchedulePage($event);
        } else if (this.selectedLeaguePage == "Standings") {
            this.gotoStandingsPage($event);
        } else if (this.selectedLeaguePage == "Players") {
            this.gotoPlayersPage($event);
        } else if (this.selectedLeaguePage == "Stats") {
            this.gotoStatsPage($event);
        }
    }

}
